<ion-header [translucent]="true">
  <ion-toolbar color="primary" class="custom-toolbar">
    <div class="level-indicator" slot="primary">
      <div class="level-glow"></div>
      <div class="level-text">
        <div class="help-button" (click)="showWriteOrder(letter)">
          <ion-icon name="brush-outline"></ion-icon>
          <span>{{ 'Writing Order' | translate }}</span>
        </div>
        <div class="divider"></div>
        <div class="help-button" (click)="showManual = !showManual">
          <ion-icon name="help-circle-outline"></ion-icon>
          <span>{{ 'Writing Guide' | translate }}</span>
        </div>
      </div>
    </div>

    <ion-button slot="start" size="small" routerLink="/"><ion-icon name="book-outline"></ion-icon> {{ 'Learn' | translate }}</ion-button>
    <ion-button slot="end" size="small" (click)="resetSelection()"><ion-icon name="trash-outline"></ion-icon> {{ 'Clear' | translate }}</ion-button>
  </ion-toolbar>
  <div class="transliteration-container" *ngIf="romanTransliteration">
    <div class="transliteration-pill">
      <span class="transliteration-text">{{romanTransliteration}}</span>
    </div>
  </div>
</ion-header>

<ion-content>
  <div class="writing-guide-modal" *ngIf="showManual" (click)="showManual = false">
    <div class="writing-guide-content" (click)="$event.stopPropagation()">
      <div class="writing-guide-header">
        <h2>{{ 'Tamil Letter Writing Guide' | translate }}</h2>
        <ion-icon name="close-outline" (click)="showManual = false"></ion-icon>
      </div>

      <div class="writing-guide-body">
        <div class="guide-section">
          <h3>1. {{ 'How to Write' | translate }}</h3>
          <div class="guide-content">
            <ul>
              <li>{{ 'Select a Tamil letter from the keyboard below' | translate }}</li>
              <li>{{ 'The letter will appear in light color on the canvas' | translate }}</li>
              <li>{{ 'Trace over the letter with your finger or mouse' | translate }}</li>
              <li>{{ 'Stay within the letter boundaries while tracing' | translate }}</li>
            </ul>
          </div>
        </div>

        <div class="guide-section">
          <h3>2. {{ 'Writing Order Guide' | translate }}</h3>
          <div class="guide-content">
            <ul>
              <li>{{ 'Click the "Writing Order" button in the top bar to see stroke order' | translate }}</li>
              <li>{{ 'View both static images and video demonstrations' | translate }}</li>
              <li>{{ 'Green dot indicates stroke start point' | translate }}</li>
              <li>{{ 'Red dot indicates stroke end point' | translate }}</li>
              <li>{{ 'Follow numbered strokes for correct writing sequence' | translate }}</li>
            </ul>
          </div>
        </div>

        <div class="guide-section">
          <h3>3. {{ 'Font Selection' | translate }}</h3>
          <div class="guide-content">
            <ul>
              <li>{{ 'Click the font selector in the top-right of canvas' | translate }}</li>
              <li>{{ 'Choose from Modern Scripts for contemporary writing styles' | translate }}</li>
              <li>{{ 'Select Old Scripts to practice historical Tamil writing' | translate }}</li>
              <li>{{ 'Each font provides unique stroke patterns and styles' | translate }}</li>
            </ul>
          </div>
        </div>

        <div class="guide-section">
          <h3>4. {{ 'Controls' | translate }}</h3>
          <div class="guide-content">
            <ul>
              <li>{{ 'Clear: Erases your current tracing' | translate }}</li>
              <li>{{ 'Keyboard: Select different letters to practice' | translate }}</li>
            </ul>
          </div>
        </div>

        <div class="guide-section">
          <h3>5. {{ 'Tips for Better Writing' | translate }}</h3>
          <div class="guide-content">
            <ul>
              <li>{{ 'Follow the correct stroke order' | translate }}</li>
              <li>{{ 'Practice each letter multiple times' | translate }}</li>
              <li>{{ 'Try to maintain consistent speed while tracing' | translate }}</li>
              <li>{{ 'Use the transliteration guide for pronunciation' | translate }}</li>
              <li>{{ 'Experiment with different fonts to understand variations' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-content-wrapper" [class.blur-background]="showManual">
    <div class="canvas-container">
      <div class="font-selector-floating">
        <div class="font-select-button" (click)="toggleFontSelect($event)">
          <ion-icon name="text-outline"></ion-icon>
          <span>{{ (selectedFont?.displayNameKey || 'FONT.DEFAULT') | translate }}</span>
        </div>
        <div class="font-options" [class.show]="showFontSelect">
          <div *ngFor="let category of categorizedFonts" class="font-category">
            <div class="category-header">{{ category.nameKey | translate }}</div>
            <div class="font-option" 
                 *ngFor="let font of category.fonts" 
                 (click)="selectFont(font)"
                 [class.active]="font.name === selectedFont?.name">
              <span>{{ font.displayNameKey | translate }}</span>
              <ion-icon name="checkmark" *ngIf="font.name === selectedFont?.name"></ion-icon>
            </div>
          </div>
        </div>
      </div>
      <canvas #myCanvas></canvas>
    </div>
    <div class="letter-selection">
      <div class="keyboard-row">
        <!-- Left side: Uyir or UyirMei letters -->
        <div class="uyir-letters" [class.hidden]="selectedMei">
          <div class="letter-row">
            <button *ngFor="let letter of uyirletters.slice(0, 4)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of uyirletters.slice(4, 8)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of uyirletters.slice(8, 12)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
        </div>
        
        <!-- UyirMei letters (replaces Uyir letters) -->
        <div class="uyir-letters uyirmei" *ngIf="selectedMei">
          <div class="letter-row">
            <button *ngFor="let letter of dynamicUyirMeiLetters.slice(0, 4)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of dynamicUyirMeiLetters.slice(4, 8)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of dynamicUyirMeiLetters.slice(8, 12)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
        </div>

        <!-- Right side: Mei letters (always visible) -->
        <div class="mei-letters">
          <div class="letter-row">
            <button *ngFor="let letter of meiletters.slice(0, 6)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of meiletters.slice(6, 12)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
          <div class="letter-row">
            <button *ngFor="let letter of meiletters.slice(12, 18)" (click)="selectLetter(letter)">
              {{ letter }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<div class="stroke-order-modal" *ngIf="WriteOrderVisible" (click)="hideWriteOrder()">
  <div class="stroke-order-content" (click)="$event.stopPropagation()">
    <div class="stroke-order-header">
      <h2>{{ 'How to write' | translate }} "{{currentCharacter}}"</h2>
      <div class="header-actions">
        <ion-icon name="close-outline" (click)="hideWriteOrder()"></ion-icon>
      </div>
    </div>

    <ion-segment [(ngModel)]="selectedDemoType" mode="ios">
      <ion-segment-button value="image">
        <ion-icon name="image-outline"></ion-icon>
        <ion-label>{{ 'Image' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="video">
        <ion-icon name="film-outline"></ion-icon>
        <ion-label>{{ 'Video' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>

    <div [ngSwitch]="selectedDemoType">

      <div class="stroke-guide"  *ngSwitchCase="'image'">
        <div class="guide-item">
          <div class="dot start-dot"></div>
          <span>{{ 'Start here' | translate }}</span>
        </div>
        <div class="guide-item">
          <div class="dot end-dot"></div>
          <span>{{ 'End here' | translate }}</span>
        </div>
      </div>
      <!-- Static stroke order image -->
      <div class="stroke-order-image" *ngSwitchCase="'image'">
        <img [src]="getWriteOrderImage(currentCharacter)">
      </div>

      <div class="stroke-order-footer" *ngSwitchCase="'image'">
        <p>{{ 'Follow the numbered strokes to write correctly' | translate }}</p>
      </div>

      <!-- Video demonstration -->
      <div class="video-container" *ngSwitchCase="'video'">
        <video #strokeVideo
               *ngIf="selectedDemoType === 'video'"
               [src]="getWriteOrderVideo(currentCharacter)"
               (loadeddata)="onVideoLoaded()"
               (error)="onVideoError()"
               playsinline
               webkit-playsinline
               loop
               autoplay
               preload="auto"
               class="write-order-video">
        </video>
      </div>

      <div class="stroke-order-footer" *ngSwitchCase="'video'">
        <span class="credits-link" (click)="showCredits = true">
          <ion-icon name="information-circle-outline"></ion-icon>
          <span>{{ 'Video License' | translate }}</span>
        </span>
      </div>

    </div>

  </div>
</div>

<div class="credits-modal" *ngIf="showCredits" (click)="showCredits = false">
  <div class="credits-content" (click)="$event.stopPropagation()">
    <div class="credits-header">
      <h3>{{ 'Video License' | translate }}</h3>
      <h4>MyIPO CRLY2023P02640</h4>
      <ion-icon name="close-outline" (click)="showCredits = false"></ion-icon>
    </div>
    <div class="credits-body">
      <div class="credits-team">
        <h4>{{ 'Innovation Team Members' | translate }}</h4>
        <ul>
          <li>KUGAVENTHIRAAH G SELVA RAJ</li>
          <li>YOGASRI R. RAVI</li>
          <li>KHIRTHANA SAI RAMU</li>
          <li>SESHMITHA P RAVI</li>
        </ul>
      </div>
      <div class="credits-supervisor">
        <h4>{{ 'Supervising Lecturer' | translate }}</h4>
        <p>Dr. ARULNATHAN VISURASAM</p>
      </div>
      <div class="credits-institution">
        <p>Institut Pendidikan Guru Kampus Ipoh</p>
        <p>31150 Hulu Kinta</p>
        <p>Perak Darul Ridzuan</p>
        <p>MALAYSIA</p>
      </div>
    </div>
  </div>
</div>

<ion-footer>
  <div class="ion-text-center footer-style">
    <span>© 2025 TAMIL.MY · <a href="https://otpam.com" target="_blank" class="footer-link">OTPAM SDN BHD (1446394-V).</a> All Rights Reserved.</span>
  </div>     
</ion-footer>